import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Input } from '@cian/ui-kit';
import { ModalConfirm } from '../../components/ModalConfirm';
import { useDispatch, useSelector } from 'react-redux';
import { hideModalCreateFolder } from '../../actions';
import { selectIsShowModalCreateFolder } from '../../selectors';
import { jsx as _jsx } from "react/jsx-runtime";
export function ModalCreateContainer(_ref) {
  var onConfirm = _ref.onConfirm;
  var dispatch = useDispatch();
  var isShowModal = useSelector(selectIsShowModalCreateFolder);
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    name = _React$useState2[0],
    setName = _React$useState2[1];
  if (!isShowModal) {
    return null;
  }
  return /*#__PURE__*/_jsx(ModalConfirm, {
    text: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0432 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0443",
    isVisible: true,
    isLoading: false,
    confirmButtonDisabled: !name,
    onConfirm: function (_onConfirm) {
      function onConfirm() {
        return _onConfirm.apply(this, arguments);
      }
      onConfirm.toString = function () {
        return _onConfirm.toString();
      };
      return onConfirm;
    }(function () {
      return onConfirm(name);
    }),
    onCancel: function onCancel() {
      return dispatch(hideModalCreateFolder());
    },
    children: /*#__PURE__*/_jsx(Input, {
      placeholder: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0438",
      maxLength: 150,
      onChange: function onChange(e) {
        return setName(e.target.value);
      },
      value: name
    })
  });
}